// Sopwith 3D - gamepad input.
//
// Standard-mapping pads: left stick or d-pad pitches, A fires, B bombs,
// X flips, Y calls the autopilot, right trigger throttles up and left
// trigger down. Flip is edge-triggered like the keyboard.

import {
  K_ACCEL,
  K_BOMB,
  K_DEACC,
  K_FLAPD,
  K_FLAPU,
  K_FLIP,
  K_HOME,
  K_SHOT,
} from '../sim/constants';

export class GamepadInput {
  private prevFlip = false;
  /** True once any pad has been seen; used to show pad hints. */
  connected = false;

  private unavailable = false;

  poll(): number {
    if (this.unavailable) return 0;
    let pads: (Gamepad | null)[];
    try {
      pads = typeof navigator !== 'undefined' && navigator.getGamepads ? navigator.getGamepads() : [];
    } catch {
      // Embedded frames without the gamepad permission throw here.
      this.unavailable = true;
      return 0;
    }
    let keys = 0;
    let flip = false;
    for (const pad of pads) {
      if (!pad) continue;
      this.connected = true;
      const b = (i: number): boolean => !!pad.buttons[i] && (pad.buttons[i].pressed || pad.buttons[i].value > 0.5);
      const ay = pad.axes[1] ?? 0;
      if (ay < -0.5 || b(12)) keys |= K_FLAPU;
      if (ay > 0.5 || b(13)) keys |= K_FLAPD;
      if (b(0)) keys |= K_SHOT;
      if (b(1)) keys |= K_BOMB;
      if (b(2)) flip = true;
      if (b(3)) keys |= K_HOME;
      if (b(7) || b(5)) keys |= K_ACCEL;
      if (b(6) || b(4)) keys |= K_DEACC;
    }
    if (flip && !this.prevFlip) keys |= K_FLIP;
    this.prevFlip = flip;
    return keys;
  }
}
